import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import DeleteCardRequest from './deleteCard.repository';

type InitialState = {
  loading: boolean;
  data?: any;
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};


export const deleteCard = createAsyncThunk(
  'deleteCard',
  async (cardId: number) => {
    return await DeleteCardRequest(cardId);
  }
);


const deleteCardSlice = createSlice({
  name: 'deleteCard',
  initialState,
  reducers: {
    deleteCardReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteCard.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });

    builder.addCase(
      deleteCard.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );

    builder.addCase(deleteCard.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default deleteCardSlice.reducer;

export const { deleteCardReset } = deleteCardSlice.actions;